import { AdvanceFilter } from './../../models/advance-filter';
import { JobFilter } from './../../models/job-filter';
import { UiStateStore } from '../../../shared/store/ui-state-store.service';
import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { JobsStore } from '../../store/jobs-store.service';
import { Subscription } from 'rxjs';
import { JobMappings } from '../../../shared/mappings/job-mappings';

@Component({
  selector: 'job-filter',
  templateUrl: './job-filter.component.html',
  styleUrls: ['./job-filter.component.scss']
})
export class JobFilterComponent implements OnInit, OnDestroy {

  @Input() isHomePage: boolean;
  public jobFilter: JobFilter;
  private _subscription: Subscription;
  public _advanceFilter: AdvanceFilter;

  constructor(private jobStore: JobsStore,
    private router: Router,
    private _uiStateStore: UiStateStore) {
    this.jobFilter = new JobFilter();
    this._subscription = this.jobStore.jobSearchFilter.subscribe(filter => {
      if (!filter) {
        return;
      }

      this.jobFilter = filter;
    });

    this._subscription = this._uiStateStore.advanceJobFilterSelection$.subscribe(resp => {
      if (resp) {
        this._advanceFilter = resp;
      }
    });
  }

  ngOnInit() {
    if(this.isHomePage) {
      this.jobFilter = new JobFilter();
    }
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  filterJobs(): void {
    if (this.isHomePage && this._advanceFilter) {
      this.jobFilter = JobMappings.MapAdvFilterToJobFilter(this._advanceFilter, this.jobFilter);
    }
    this.jobStore.loadSearchResults(this.jobFilter);
    this.router.navigate(['/search-jobs']);
  }

}
